import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {UserStatistics} from '@/app/core/models/stats';

@Injectable({
	providedIn: 'root'
})
export class StatisticsService {

	private http = inject(HttpClient);

	private readonly SERVICE_URI = `${environment.backendUrl}/statistic`;

	getUserStatistics() : Observable<UserStatistics> {
		return this.http.get<UserStatistics>(this.SERVICE_URI);
	}

}
